const parse = (iso) => (iso ? new Date(`${iso}T12:00:00`) : null);

export const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const fmtDate = (iso) =>
  iso ? parse(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "—";

export const fmtDayMonth = (iso) =>
  iso ? parse(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short" }) : "—";

export const fmtLongToday = () => {
  const s = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const fmtMoney = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0).replace(/\u202f/g, "\u00a0");

export const fmtNumber = (n) => new Intl.NumberFormat("fr-FR").format(n || 0).replace(/\u202f/g, "\u00a0");

export const MAX_PHOTO = 5 * 1024 * 1024;

export function compressImage(file, maxSide = 1600, quality = 0.8) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("Compression impossible"))), "image/jpeg", quality);
    };
    img.onerror = () => reject(new Error("Image illisible"));
    img.src = url;
  });
}
